module.exports = __webpack_public_path__ + "img/sad-face-avatar.5ff57173.webp";